import {FormattedMessage} from "react-intl";
import React from "react";
import {OTLink} from "../../../../../../components/tag/OTLink";
import BiobankLaboratoryInfo from "../../../../../timeline/components/laboratory/BiobankLaboratoryInfo";

let { id: module_id } = module;
export const TimelineFrameContentFimlabInstructions = ({data}) => {

    const {
        fasting,
        collectionTimeWindowEnd,
        collectionTimeWindowStart,
        requestedCollectionDateDate,
        requestedCollectionDateTime,
        biopankki
    } = data;

    return (
        <>
            <FormattedMessage id={`${module_id}.title`}
                              values={{
                                  strong: (chunks) => <strong>{chunks}</strong>
                              }}
            />
            <ul className="dash timeline-frame-fimlab-instructions">
                <li>
                    <FormattedMessage
                        id={`${module_id}.instruction.appointment`}
                        values={{
                            a: (chunks) => <OTLink
                                target="_blank"
                                onClick={(e) => e.stopPropagation()}
                                link={"https://fimlab.fi/ajanvaraus"}
                                isExternal={true}
                                className="card-link"
                            >{chunks}</OTLink>
                        }}
                    />
                </li>
                <li>
                    <FormattedMessage id={`${module_id}.instruction.location`}
                                      values={{
                                        requestedCollectionDateDate,
                                        collectionTimeWindowStart
                                      }}
                    />
                </li>
                <li>
                    <FormattedMessage
                        id={
                            fasting && fasting > 0
                                ? 'fimlab.description.fasting'
                                : 'fimlab.description.no.fasting'
                        }
                        values={{
                            fasting: fasting,
                            strong: (chunks) => <strong>{chunks}</strong>,
                            br: <br />,
                        }}
                    />
                </li>
                <li>
                    <FormattedMessage id={`${module_id}.instruction.equipment`} />
                </li>
                <li>
                    <FormattedMessage
                        id={`${module_id}.instruction.preparation`}
                        values={{
                            a: (chunks) => <OTLink
                                target="_blank"
                                onClick={(e) => e.stopPropagation()}
                                link={"https://fimlab.fi/nain-valmistaudut-tutkimuksiin/"}
                                isExternal={true}
                                className="card-link"
                            >{chunks}</OTLink>
                        }}
                    />
                </li>
                {biopankki && (
                    <li>
                        <BiobankLaboratoryInfo
                            theme={isNotification ? 'blue' : 'white'}
                        />
                    </li>
                )}
            </ul>
        </>
    )
}